import { createContext } from 'react';

export type Politeness = 'polite' | 'assertive';

export interface AnnouncerContextValue {
  /** Sends a message to the screen-reader live region. */
  announce: (message: string, politeness?: Politeness) => void;
}

export const AnnouncerContext = createContext<AnnouncerContextValue | null>(null);
